var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const GET_SET_STRIPE = 'api/stripe';
const GENERATE_EXTRA_PACKAGE_CHECKOUT_SESSION = 'api/billing/extra-packages/checkout';
export const createCreateSuscriptionCheckoutSession = function (data) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            const response = yield this.axiosInstance.post(`${GET_SET_STRIPE}/create-subscription-checkout-session`, data, config);
            return response;
        }
        catch (error) {
            console.error('Error fetching createCreateSuscriptionCheckoutSession:', error);
            throw error;
        }
    });
};
export const createCustomerPortalSession = function (data) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            const response = yield this.axiosInstance.post(`${GET_SET_STRIPE}/create-customer-portal-session`, data, config);
            return response;
        }
        catch (error) {
            console.error('Error fetching createCustomerPortalSession:', error);
            throw error;
        }
    });
};
/** @deprecated Legacy standalone CFDI checkout. New activations use companies.enableCFDIAddon. */
export const createCFDISuscrptionCheckoutSession = function (data) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            const response = yield this.axiosInstance.post(`${GET_SET_STRIPE}/create-cfdi-subscription-checkout-session`, data, config);
            return response;
        }
        catch (error) {
            console.error('Error fetching createCFDISuscrptionCheckoutSession:', error);
            throw error;
        }
    });
};
export const createGetMoreCheckoutSession = function (data) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            return yield this.axiosInstance.post(`${GENERATE_EXTRA_PACKAGE_CHECKOUT_SESSION}`, data, config);
        }
        catch (error) {
            console.error('Error fetching createGetMoreCheckoutSession:', error);
            throw error;
        }
    });
};
